module.exports = __webpack_public_path__ + "img/bg_dashboard.45857383.png";